var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bun-canvas configurator-element"},[_c('BunName'),_c('Bun'),_c('EmojiLibrary'),_c('div',{staticClass:"section-footer"},[_c('div',{staticClass:"disclaimer"},[_vm._v(" "+_vm._s(_vm.$t('notification.disclaimer'))+" ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }